export default __webpack_public_path__ + "media/images/banner/banner-30-47adb2861cbc0898e20d75927abd11d5.jpg";